'use strict';

var formVehicleVVS = function () {
  var hasTpv = void 0;
  var _setHasTpv = function _setHasTpv(value) {
    return hasTpv = value;
  },
      _getHasTpv = function _getHasTpv() {
    return hasTpv;
  };
  var _init = function _init(dealerName, codhost, model, comercialCode, hasTpv) {
    _setHasTpv(hasTpv);
    $.getJSON('' + urlsVVS.api + codhost + '/' + model + '/' + comercialCode, function (vehicleData) {
      var currentVehicle = vehicleData.dealersVehicles[0];
      vehicleVVS.setCurrentVehicleData(vehicleData.dealersVehicles[0]);
      vehicleVVS.setCurrentVehicle(currentVehicle.vehicle);
      vehicleVVS.setCurrentPrices(currentVehicle.prices);
      // vehicleVVS.printTitle(dealerName, currentVehicle.vehicle.vdisplayModelo)
      vehicleVVS.displayGeneralData();
      vehicleVVS.displayImages();
      _printBreadCrum(currentVehicle.vehicle);
      _printFinancial(currentVehicle);
      _initFormsValidation();
      $('.js-tab-radio').on('change', function () {
        _resetForms();
      });
    });
  };

  var _printBreadCrum = function _printBreadCrum(vehicle) {
    var modelPath = utilsVVS.getDisplayModelName(vehicle.vdisplayModelo).completeName.toLowerCase().replace(' ', '-');
    var modelName = utilsVVS.getDisplayModelName(vehicle.vdisplayModelo).completeName;
    var vehiclePath = vehicle.vcodcom17;
    var versionName = vehicle.vgrado;

    $('.js-prev').text(modelName).attr('href', '../../' + modelPath);
    $('.js-prev-2').text(modelName + ' ' + versionName).attr('href', '../' + vehiclePath);
    $('.js-page').text('Da el siguiente paso');
  };

  var _printFinancial = function _printFinancial(vehicleData) {
    if (sessionStorage.cafi) {
      var cafiData = JSON.parse(sessionStorage.cafi);
      if (cafiData[vehicleData.vehicle.vcodcom17]) {
        var financialObj = cafiData[vehicleData.vehicle.vcodcom17];
        $('.js-cafi-cuota').text(utilsVVS.formatPrice(financialObj.cuota_financiera, 1));
        $('.js-cafi-open').removeClass('hidden');
      }
    }
  };

  var _resetForms = function _resetForms() {
    var currentCodhost = void 0;
    if ($('.js-field-dealer').val().trim() !== '') currentCodhost = $('.js-field-dealer').val();
    document.forms.formOffer.reset();
    document.forms.formSale.reset();
    if (typeof currentCodhost !== 'undefined') $('.js-field-dealer').val(currentCodhost);
  };

  var _initFormsValidation = function _initFormsValidation() {
    var requiredTxt = 'Campo obligatorio';
    var formOfferParams = {
      selector: '#formOffer',
      dealerType: 'general',
      dealerSelect: '.js-field-dealer',
      options: {
        errorPlacement: function errorPlacement(error, element) {
          if (element[0].name === 'pcodHost') {
            console.log('#1', error);
            $('.js-dlr-name').empty().append(error);
          } else {
            console.log('#2');
            element.after(error);
          }
          error.addClass('h-error');
        },
        submitHandler: function submitHandler(form) {
          $('.js-label-submit').prop('disabled', true).text('ENVIANDO...');
          form.submit();
        },
        rules: {
          dealer: {
            required: true,
            messages: {
              required: 'Selecciona un concesionario'
            }
          },
          surname1: {
            required: true,
            alphabetical: true,
            messages: {
              required: requiredTxt,
              alphabetical: 'Sólo caracteres alfabéticos'
            }
          },
          mobilephone: {
            required: true,
            mobilePhoneES_AD: true,
            messages: {
              required: requiredTxt,
              mobilePhoneES_AD: 'Teléfono móvil no válido'
            }
          },
          postalcode: {
            required: true,
            cpES_AD: true,
            messages: {
              required: requiredTxt,
              cpES_AD: 'Código postal no válido'
            }
          }
        }
      }
    };

    var formSaleParams = void 0;

    if (_getHasTpv()) {
      formSaleParams = {
        selector: '#formSale',
        dealerType: 'general',
        dealerSelect: '.js-field-dealer',
        options: {
          errorPlacement: function errorPlacement(error, element) {
            if (element[0].name === 'pcodHost') {
              console.log('#1', error);
              $('.js-dlr-name').empty().append(error);
            } else {
              console.log('#2');
              element.after(error);
            }
            error.addClass('h-error');
          },
          submitHandler: function submitHandler(form) {
            $('.js-label-submit').prop('disabled', true).text('ENVIANDO...');
            form.submit();
          },
          rules: {
            dealer: {
              required: true,
              messages: {
                required: 'Selecciona un concesionario'
              }
            },
            surname1: {
              required: true,
              alphabetical: true,
              messages: {
                required: requiredTxt,
                alphabetical: 'Sólo caracteres alfabéticos'
              }
            },
            surname2: {
              required: true,
              alphabetical: true,
              messages: {
                required: requiredTxt,
                alphabetical: 'Sólo caracteres alfabéticos'
              }
            },
            mobilephone: {
              required: true,
              mobilePhoneES_AD: true,
              messages: {
                required: requiredTxt,
                mobilePhoneES_AD: 'Teléfono móvil no válido'
              }
            },
            nif: {
              required: true,
              nifNie: true,
              messages: {
                required: requiredTxt,
                nifNie: 'Formato N.I.F. no válido'
              }
            },
            postalcode: {
              required: true,
              cpES_AD: true,
              messages: {
                required: requiredTxt,
                cpES_AD: 'Código postal no válido'
              }
            },
            birthdate: {
              required: true,
              dateEsFormat: true,
              messages: {
                required: requiredTxt,
                dateEsFormat: 'El formato debe ser dd/mm/aaaa'
              }
            },
            citizenship: {
              required: true,
              messages: {
                required: requiredTxt
              }
            },
            address: {
              required: true,
              messages: {
                required: requiredTxt
              }
            }
          }
        }
      };
    }
    formsVVS.init(formOfferParams);
    if (typeof formSaleParams !== 'undefined') formsVVS.init(formSaleParams);
  };

  return {
    init: _init
  };
}();